// extracted by mini-css-extract-plugin
export default {"main":"styles_main__ZBv1P","link":"styles_link__By7dh"};